module.exports = __webpack_public_path__ + "img/js_action.4c64f271.png";